module.exports = __webpack_public_path__ + "e78e2dc0c13d2e8e72c98f0a87105f5c.png";